import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { ProductListing } from '@df/catalog-ui/listing/product-listing';
import { App } from '@df/core/app';
import { BodyClassService } from '@df/ui/body-class.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ProductListingComponent } from '../product-listing.component';
import { ListingSizeComponent } from '../size/listing-size.component';
import { ListingSortComponent } from '../sort/listing-sort.component';
import { FiltersComponent } from './filters.component';

@Component({
    selector: 'product-listing-filters',
    templateUrl: './product-listing-filters.component.html',
    styleUrl: './product-listing-filters.component.scss',
    standalone: true,
    imports: [CommonModule, FiltersComponent, ListingSizeComponent, ListingSortComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListingFiltersComponent extends UiComponent {
    readonly app = inject(App);
    protected bodyClassService = inject(BodyClassService);

    @Input()
    productListingComponent!: ProductListingComponent;

    @Input()
    displayModelViewSwitch!: boolean;

    @Input()
    listing: ProductListing | undefined;

    override ngOnInit() {
        this.bodyClassService.add('product-listing-filters', this);

        super.ngOnInit();
    }

    override ngOnDestroy(): void {
        this.bodyClassService.remove('product-listing-filters', this);

        super.ngOnDestroy();
    }
}
